import { render } from "./TabularDatasetExport.vue?vue&type=template&id=07721dbb&scoped=true"
import script from "./TabularDatasetExport.vue?vue&type=script&lang=js"
export * from "./TabularDatasetExport.vue?vue&type=script&lang=js"

import "./TabularDatasetExport.vue?vue&type=style&index=0&id=07721dbb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07721dbb"]])

export default __exports__